import { Component, OnInit } from "@angular/core";
import { BigmlFieldDTO } from "@DTOS";

@Component({
    templateUrl: "./tipo-ensemble-configuracion-modal.component.html",
    styleUrls: ["./tipo-ensemble-configuracion-modal.component.scss"]
})
export class TipoEnsembleConfiguracionModalComponent implements OnInit {
    public campo: BigmlFieldDTO = new BigmlFieldDTO();

    constructor() { }

    ngOnInit(): void {
    }

}
